import React from 'react';
import { ConfettiIcon, GradientName } from './icons';

const confettiPaths = [
  { width: 12, height: 12, d: "M11.5331 5.79979L5.33231 0.655273L0.167816 6.83211L6.36863 11.9766L11.5331 5.79979Z" },
  { width: 21, height: 21, d: "M8.6799 20.503L20.8608 12.1387L12.464 0.00481174L0.283085 8.36914L8.6799 20.503Z" },
  { width: 18, height: 18, d: "M11.5789 17.1981L17.2205 5.81738L5.79562 0.197651L0.154059 11.5783L11.5789 17.1981Z" },
  { width: 11, height: 11, d: "M10.4755 4.16848L4.18964 0.0224609L0.0275245 6.28403L6.31341 10.4301L10.4755 4.16848Z" },
  { width: 11, height: 11, d: "M9.57088 10.2099L10.6976 1.3252L1.77845 0.202798L0.651701 9.08746L9.57088 10.2099Z" },
  { width: 9, height: 9, d: "M0.129762 7.778L7.08932 8.85742L8.17294 1.92479L1.21338 0.84536L0.129762 7.778Z" },
  { width: 14, height: 15, d: "M1.8349 14.1191L13.8116 12.3701L12.0559 0.439715L0.0791474 2.18868L1.8349 14.1191Z" },
  { width: 15, height: 14, d: "M1.21147 13.6913L14.2994 13.2383L13.8446 0.201038L0.756717 0.654032L1.21147 13.6913Z" },
  { width: 17, height: 17, d: "M0.103625 14.4342L14.4409 16.8857L16.9019 2.60395L2.56464 0.152456L0.103625 14.4342Z" },
  { width: 17, height: 17, d: "M16.8161 3.58165L3.4328 0.361328L0.199977 13.6929L13.5833 16.9132L16.8161 3.58165Z" },
  { width: 11, height: 12, d: "M0.823996 11.183L10.3481 10.4014L9.56339 0.914108L0.0393003 1.69577L0.823996 11.183Z" },
  { width: 20, height: 19, d: "M13.5404 0.308056L0.732239 6.14941L6.59629 18.9081L19.4045 13.0667L13.5404 0.308056Z" },
  { width: 9, height: 9, d: "M0.558952 1.52022L1.70398 8.58594L8.79718 7.44533L7.65215 0.379614L0.558952 1.52022Z" },
  { width: 17, height: 18, d: "M16.7942 11.0825L10.7049 0.702148L0.284282 6.76792L6.3736 17.1482L16.7942 11.0825Z" },
  { width: 21, height: 21, d: "M7.27944 0.891197L0.735107 14.3047L14.2007 20.8237L20.745 7.41023L7.27944 0.891197Z" },
  { width: 12, height: 11, d: "M11.1166 2.12363L2.25995 0.0576172L0.185898 8.88003L9.04251 10.9461L11.1166 2.12363Z" },
  { width: 18, height: 18, d: "M17.9124 4.01951L4.41754 0.119141L0.502035 13.5618L13.9969 17.4622L17.9124 4.01951Z" },
  { width: 16, height: 17, d: "M15.0672 16.259L15.9935 1.83301L1.5116 0.910237L0.585244 15.3362L15.0672 16.259Z" },
  { width: 16, height: 16, d: "M1.63805 0.445849L0.271851 14.5537L14.4345 15.9146L15.8007 1.80677L1.63805 0.445849Z" },
  { width: 15, height: 14, d: "M6.12979 13.6507L14.0132 8.02441L8.36512 0.171492L0.481667 5.79781L6.12979 13.6507Z" },
  { width: 14, height: 14, d: "M0.218931 10.9537L10.6124 13.5869L13.2559 3.23364L2.8624 0.600397L0.218931 10.9537Z" },
  { width: 14, height: 14, d: "M0.431628 2.94267L3.13495 13.1348L13.3666 10.4419L10.6633 0.249799L0.431628 2.94267Z" },
  { width: 12, height: 12, d: "M0.101331 9.47477L9.46198 11.208L11.2019 1.88357L1.84129 0.150339L0.101331 9.47477Z" },
  { width: 22, height: 22, d: "M11.6616 21.4683L21.585 10.6807L10.7555 0.795633L0.832106 11.5833L11.6616 21.4683Z" },
  { width: 10, height: 10, d: "M0.400405 1.49016L1.24817 9.73242L9.52245 8.88793L8.67469 0.645673L0.400405 1.49016Z" },
  { width: 13, height: 13, d: "M0.781912 5.60952L5.67358 12.5273L12.6183 7.65459L7.72659 0.736764L0.781912 5.60952Z" },
  { width: 11, height: 11, d: "M2.07007 10.6033L10.7687 8.80566L8.96417 0.140649L0.265495 1.93825L2.07007 10.6033Z" },
  { width: 15, height: 15, d: "M0.430886 4.14382L4.4483 14.0488L14.3918 10.0469L10.3744 0.141928L0.430886 4.14382Z" },
  { width: 17, height: 17, d: "M13.2264 16.5564L16.2769 3.87012L3.54137 0.831438L0.490896 13.5177L13.2264 16.5564Z" },
  { width: 14, height: 14, d: "M13.3733 2.29836L1.81384 0.630859L0.139864 12.1456L11.6993 13.8131L13.3733 2.29836Z" },
  { width: 18, height: 17, d: "M12.2006 16.5946L17.1606 5.09473L5.61609 0.154013L0.656185 11.6539L12.2006 16.5946Z" },
  { width: 12, height: 12, d: "M11.2972 4.4689L4.20093 0.423828L0.140148 7.49265L7.23641 11.5377L11.2972 4.4689Z" },
  { width: 14, height: 14, d: "M5.82492 0.546554L0.909729 8.62793L9.02248 13.5241L13.9377 5.44274L5.82492 0.546554Z" },
  { width: 12, height: 12, d: "M11.7397 3.04215L2.95218 0.841797L0.743285 9.5953L9.53076 11.7957L11.7397 3.04215Z" },
  { width: 9, height: 10, d: "M0.181936 2.59053L2.474 9.03809L8.94656 6.75489L6.6545 0.307337L0.181936 2.59053Z" },
  { width: 16, height: 17, d: "M7.65378 16.7265L15.938 9.24121L8.42369 0.989032L0.139481 8.47427L7.65378 16.7265Z" },
  { width: 17, height: 18, d: "M7.1328 0.686848L0.0187683 9.95898L9.32689 17.0455L16.4409 7.77336L7.1328 0.686848Z" },
];

const gradients: GradientName[] = ['gold', 'red', 'blue', 'green', 'yellow', 'pink'];

const getRandom = <T,>(arr: T[]): T => arr[Math.floor(Math.random() * arr.length)];

interface ConfettiPiece {
  id: number;
  style: React.CSSProperties;
  pathData: string;
  width: string;
  height: string;
  gradientName: GradientName;
  gradientCoordinates: { x1: string; y1: string; x2: string; y2: string; };
}

const generateConfetti = (count: number, containerWidth: number, containerHeight: number): ConfettiPiece[] => {
  const pieces: ConfettiPiece[] = [];
  const positions: { x: number; y: number }[] = [];
  const minDistance = 25;
  
  const centerX = containerWidth / 2;
  const centerY = containerHeight / 2;
  const maxRadius = Math.min(centerX, centerY);
  const centralRadius = maxRadius * 0.35; // 35% of the radius is the central zone

  while (pieces.length < count) {
    let x: number = 0, y: number = 0;
    let positionOK = false;
    let attempts = 0;

    while (!positionOK && attempts < 50) {
      const angle = Math.random() * 2 * Math.PI;
      let radius;

      if (Math.random() > 0.2) { // 80% of confetti in the outer layer
        radius = centralRadius + Math.sqrt(Math.random()) * (maxRadius - centralRadius);
      } else { // 20% anywhere
        radius = Math.sqrt(Math.random()) * maxRadius;
      }
      
      x = centerX + radius * Math.cos(angle);
      y = centerY + radius * Math.sin(angle);

      let isTooClose = false;
      for (const pos of positions) {
        const distance = Math.sqrt(Math.pow(pos.x - x, 2) + Math.pow(pos.y - y, 2));
        if (distance < minDistance) {
          isTooClose = true;
          break;
        }
      }

      if (!isTooClose) {
        positionOK = true;
        positions.push({ x, y });
      }
      attempts++;
    }

    if (positionOK) {
      const shape = getRandom(confettiPaths);
      const size = Math.random() * 15 + 8;
      pieces.push({
        id: pieces.length,
        pathData: shape.d,
        width: shape.width.toString(),
        height: shape.height.toString(),
        gradientName: getRandom(gradients),
        gradientCoordinates: {
          x1: (Math.random() * 200 - 100).toString(),
          y1: (Math.random() * 200 - 100).toString(),
          x2: (Math.random() * 200 - 100).toString(),
          y2: (Math.random() * 200 - 100).toString(),
        },
        style: {
          position: 'absolute',
          left: `${x}px`,
          top: `${y}px`,
          transform: `rotate(${Math.random() * 360}deg)`,
          width: `${size}px`,
          height: `${size}px`,
        },
      });
    }
  }
  return pieces;
};


const ConfettiContainer: React.FC = () => {
    const [confettiPieces, setConfettiPieces] = React.useState<ConfettiPiece[]>([]);
    
    React.useEffect(() => {
        setConfettiPieces(generateConfetti(280, 1400, 1400));
    }, []);

    return (
        <div style={{ position: 'fixed', top: 50, left: '50%', transform: 'translateX(-50%)', width: '100%', maxWidth: '1400px', height: '1400px', pointerEvents: 'none', zIndex: 9999, borderRadius: '100%' }}>
            {confettiPieces.map((piece) => (
                <ConfettiIcon
                    key={piece.id}
                    width={piece.width}
                    height={piece.height}
                    pathData={piece.pathData}
                    gradientName={piece.gradientName}
                    gradientCoordinates={piece.gradientCoordinates}
                    style={piece.style}
                />
            ))}
        </div>
    );
};

export default ConfettiContainer;
